import { Link } from 'react-router';
import { diccionarioDe, type Idioma } from '../../../i18n/index.js';
import { COMO_FUNCIONA } from '../comoFunciona.js';
import { useSesion } from '../../../common/hooks/useSesion.js';

/** Explica el recorrido de uso de Athena y el valor de los estudios para el cliente. */
export function ComoFuncionaPage({ idioma }: { readonly idioma: Idioma }) {
  const sesion = useSesion();
  const t = diccionarioDe(idioma).cuentas.asistentes.deFuera;

  return (
    <div className='flex grow flex-col'>
      <main className='mx-auto flex w-full max-w-[720px] grow flex-col gap-10 px-6 py-12'>
        <h1 className='m-0 font-(family-name:--serif) text-[38px] leading-tight font-bold'>
          {idioma === 'es' ? 'Cómo funciona Athena' : 'How Athena works'}
        </h1>

        {COMO_FUNCIONA[idioma].map(seccion => (
          <section key={seccion.titulo}>
            <h2 className='m-0 mb-3 font-(family-name:--serif) text-[22px] font-bold'>{seccion.titulo}</h2>
            {seccion.parrafos.map(p => (
              <p key={p.slice(0, 30)} className='mt-0 mb-4 font-(family-name:--text) text-[16px] leading-[1.65] text-(--ink)'>
                {p}
              </p>
            ))}
          </section>
        ))}

        <Link
          to={sesion ? '/mi-cuenta' : '/registro?volver=%2Fmi-cuenta'}
          className='sobre-teal w-fit rounded-full bg-(--teal-deep) px-5 py-3 font-(family-name:--text) text-[15px]'
        >
          {sesion ? (idioma === 'es' ? 'Ir a Mi cuenta' : 'Go to My account') : t.crear}
        </Link>
      </main>
    </div>
  );
}
